import { useFormStore } from '../../lib/store';
import FieldRenderer from '../FieldRenderer';
import ModuleCard from '../ModuleCard';
import CopyButton from '../CopyButton';
import { formatNtd } from '../ui';

interface PaymentModuleProps {
  module: {
    id: string;
    name: string;
    nameEn?: string;
    fields: any[];
    settings: {
      bankName?: string;
      bankCode?: string;
      accountNumber?: string;
      accountName?: string;
      showPriceReference?: boolean;
      deadlineNote?: string;
    };
  };
  event: any;
}

export default function PaymentModule({ module, event }: PaymentModuleProps) {
  const settings = module.settings || {};
  const { totalAmount } = useFormStore();

  const bankName = settings.bankName || event.paymentBankName;
  const bankCode = settings.bankCode || event.paymentBankCode;
  const accountNumber = settings.accountNumber || event.paymentAccountNumber;
  const accountName = settings.accountName || event.paymentAccountName;

  return (
    <ModuleCard title={module.name} subtitle={settings.deadlineNote || '送出報名後再匯款也可以，匯款資訊會留在「我的報名」。'}>
      {(bankName || accountNumber) && (
        <div className="flex flex-col gap-3 p-4 rounded-card bg-soft">
          <div className="flex items-center justify-between">
            <span className="text-[13px] font-bold text-muted">匯款帳戶</span>
            <span className="text-[13px] text-muted">{[bankName, bankCode].filter(Boolean).join(' ')}</span>
          </div>
          {accountNumber && (
            <div className="flex items-center justify-between gap-3">
              <span className="tabular text-[19px] font-black break-words min-w-0">{accountNumber}</span>
              <CopyButton value={accountNumber.replace(/-/g, '')} label="複製" className="shrink-0" />
            </div>
          )}
          {accountName && <div className="text-[13px] text-muted">戶名 {accountName}</div>}
          {totalAmount > 0 && (
            <div className="flex items-center justify-between pt-3 border-t border-line">
              <span className="text-[13px] text-muted">應匯金額</span>
              <span className="tabular text-lg font-black">{formatNtd(totalAmount)}</span>
            </div>
          )}
        </div>
      )}

      {module.fields?.map((field) => <FieldRenderer key={field.id} field={field} />)}
    </ModuleCard>
  );
}
